<brn-generic-popup></brn-generic-popup>
<router-outlet></router-outlet>
